import EventDetails from '@/src/components/events/EventDetails';
import React from 'react';

export const EventDetailsPage: React.FC = () => {
  return <EventDetails />;
};
